import BaseForm from '../base';
import { ObjectPanelComponent, LatLongColumnsComponent } from '../components';
export class GatesForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'Timezone',
                key: 'timezone',
                type: 'select-timezone',
            },
            {
                label: 'Gate Type',
                key: 'gateType',
                type: 'textfield',
            },
            {
                label: 'Number of Loggers',
                key: 'numOfLoggers',
                type: 'number',
            },
            {
                label: 'Slave',
                key: 'slave',
                type: 'number',
            },
            new ObjectPanelComponent({
                label: 'Points',
                key: 'points',
                components: [
                    new ObjectPanelComponent({
                        label: 'Gate Point',
                        key: 'gatePoint',
                        components: [
                            {
                                label: 'Data Type',
                                key: 'dataType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin Type',
                                key: 'pinType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin',
                                key: 'pin',
                                type: 'number',
                            }
                        ]
                    }),
                    new ObjectPanelComponent({
                        label: 'Gate Close Point',
                        key: 'gateClosePoint',
                        components: [
                            {
                                label: 'Data Type',
                                key: 'dataType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin Type',
                                key: 'pinType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin',
                                key: 'pin',
                                type: 'number',
                            }
                        ]
                    }),
                    new ObjectPanelComponent({
                        label: 'Tamper Point',
                        key: 'tamperPoint',
                        components: [
                            {
                                label: 'Data Type',
                                key: 'dataType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin Type',
                                key: 'pinType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin',
                                key: 'pin',
                                type: 'number',
                            }
                        ]
                    }),
                    new ObjectPanelComponent({
                        label: 'Gate State',
                        key: 'gateState',
                        components: [
                            {
                                label: 'Data Type',
                                key: 'dataType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin Type',
                                key: 'pinType',
                                type: 'textfield',
                            },
                            {
                                label: 'Pin',
                                key: 'pin',
                                type: 'number',
                            }
                        ]
                    }),
                ]
            }),
        ];
    }
}
